// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vc-nav-popover-container{color:#fff;color:var(--white);font-size:var(--text-sm);font-weight:var(--font-semibold);background-color:#2d3748;background-color:var(--gray-800);border:1px solid;border-color:#4a5568;border-color:var(--gray-700);border-radius:var(--rounded-lg);padding:4px;box-shadow:var(--shadow)}.vc-is-dark .vc-nav-popover-container{color:#2d3748;color:var(--gray-800);background-color:#fff;background-color:var(--white);border-color:#f7fafc;border-color:var(--gray-100)}", ""]);
// Exports
module.exports = exports;
